// components/dashboard/DashboardFilters.jsx

import React from "react";

export default function DashboardFilters({
  inventarios,
  marcas,
  inventarioSelected,
  setInventarioSelected,
  marcaSelected,
  setMarcaSelected,
  fechaInicio,
  setFechaInicio,
  fechaFin,
  setFechaFin
}) {
  return (
    <div className="bg-gray-50 p-4 rounded-md shadow-sm mb-6 flex flex-wrap gap-4 items-center">
      <select
        value={inventarioSelected || ""}
        onChange={(e) => setInventarioSelected(parseInt(e.target.value))}
        className="border p-2 rounded-md"
      >
        {inventarios.map(inv => (
          <option key={inv.FIInventario} value={inv.FIInventario}>
            {inv.FCNombreInventario}
          </option>
        ))}
      </select>

      <select
        value={marcaSelected}
        onChange={(e) => setMarcaSelected(parseInt(e.target.value))}
        className="border p-2 rounded-md"
      >
        <option value={0}>Todas</option>
        {marcas.map(marca => (
          <option key={marca.FIMarca} value={marca.FIMarca}>
            {marca.FCNombre}
          </option>
        ))}
      </select>

      <input
        type="date"
        value={fechaInicio}
        onChange={(e) => setFechaInicio(e.target.value)}
        className="border p-2 rounded-md"
      />

      <input
        type="date"
        value={fechaFin}
        onChange={(e) => setFechaFin(e.target.value)}
        className="border p-2 rounded-md"
      />
    </div>
  );
}
